import { SPEEDS } from "./rsvp";

export const DEFAULT_PREFS = {
  rate: 1 as number,
  loop: false,
  mic: false,
};

export type Prefs = typeof DEFAULT_PREFS;

type PrefsStorage = Pick<Storage, "getItem" | "setItem"> | null;

const KEY = "perusor:prefs";

const pick = <T>(allowed: readonly T[], value: unknown, fallback: T) =>
  allowed.includes(value as T) ? (value as T) : fallback;

export function parsePrefs(raw: string | null): Prefs {
  try {
    const p = JSON.parse(raw ?? "{}") ?? {};
    return {
      rate: pick<number>(SPEEDS, p.rate, DEFAULT_PREFS.rate),
      loop: p.loop === true,
      mic: p.mic === true,
    };
  } catch {
    return DEFAULT_PREFS;
  }
}

function browserStorage(): PrefsStorage {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

export function loadPrefs(storage = browserStorage()): Prefs {
  try {
    return parsePrefs(storage?.getItem(KEY) ?? null);
  } catch {
    return DEFAULT_PREFS;
  }
}

export function savePrefs(prefs: Prefs, storage = browserStorage()) {
  try {
    storage?.setItem(KEY, JSON.stringify(prefs));
  } catch {}
}
